import {useQuery, useInfiniteQuery} from '@tanstack/react-query';
import {fetchPlace, fetchPublicPlace, fetchPlaceInterestedUsers} from '../endpoints/api';

interface FetchPlaceOptions {
  id: number;
  lat?: number;
  long?: number;
  enabled?: boolean
}

export const useFetchPlace = ({id, lat, long, enabled = true}: FetchPlaceOptions) => {
  return useQuery(['place', {id}], () => fetchPlace({id, lat, long}), {
    enabled: enabled && typeof id === 'number' && !isNaN(id),
  });
};

export const useFetchPublicPlace = (uuid) => {
  return useQuery(['public_place', {uuid}], () => fetchPublicPlace(uuid), {
    enabled: typeof uuid === 'string',
  });
};

export const useFetchPlaceInterestedUsers = (placeId: string) => {
  return useInfiniteQuery(
    ['placeInterestedUsers', placeId],
    ({pageParam = 1}) => fetchPlaceInterestedUsers(placeId, pageParam),
    {
      enabled: !!placeId,
      getNextPageParam: (lastPage) => {
        const {current_page, last_page} = lastPage.data;
        return current_page < last_page ? current_page + 1 : undefined;
      },
    }
  );
};
